import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import IconAddBlueBorder from '../../../assets/icons/IconAddBlueBorder';
import IconTableDelete from '../../../assets/icons/IconTableDelete';
import TableNexcare from '../../../components/Table/TableNexcare';
import API_MASTER_DATA from '../../../api/apiMasterData';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    MASTER_DATA_SHIFT_DELETE,
    MASTER_DATA_SHIFT_INSERT,
    MASTER_DATA_SHIFT_VIEW
} from '../../../constants/menuPermissionConstant';

class Shift extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            columns: [
                {
                    title: "ID",
                    dataIndex: "id",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-1/12",
                    render: (data) => `${data}`,
                },
                {
                    title: "Nama Shift",
                    dataIndex: "shift_name",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Deskripsi",
                    dataIndex: "shift_description",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Jam Mulai",
                    dataIndex: "work_start",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Jam Selesai",
                    dataIndex: "work_end",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Tanggal Pembuatan",
                    dataIndex: "created_at",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data === "" ? "-" : moment.utc(data).format('DD/MM/YYYY | HH:mm')}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => (
                        <div className="flex items-center space-x-3">
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_SHIFT_DELETE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btndelete" className="w-7 h-7 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showConfirmAlert: true, shiftDataSelectedDelete: data })}>
                                    <IconTableDelete />
                                </div>
                            </CheckPermissionComponent>
                            <div id="btnview" className="bg-nexcaredefault rounded-full w-7 h-7 flex justify-center items-center cursor-pointer" onClick={() => this.handleRedirectDetailShift(data)}>
                                <FontAwesomeIcon icon={faAngleRight} className="text-white text-2xl" />
                            </div>
                        </div>
                    ),
                },
            ],
            listShift: [],
            shiftDataSelectedDelete: {},
            showConfirmAlert: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleRedirectAddShift = () => {
        this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_SHIFT_ADD);
    }

    handleRedirectDetailShift = value => {
        this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_SHIFT_DETAIL.split(':')[0] + value.id);
    }

    handleDeleteShift = () => {
        this.setState({ showConfirmAlert: false });

        const shiftId = this.state.shiftDataSelectedDelete.id;
        const data = {
            updated_at: this.state.shiftDataSelectedDelete.updated_at
        }
        API_MASTER_DATA.deleteDataShift(shiftId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({ showSuccessAlert: true });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessDeleteShift = () => {
        this.setState({
            showSuccessAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateShift();
            this.getDataShift(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getInitiateShift();
                this.getDataShift(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getInitiateShift();
                this.getDataShift(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    }

    getInitiateShift = () => {
        API_MASTER_DATA.getInitiateShift(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getDataShift = (current, pageSize) => {
        API_MASTER_DATA.getListShift(current, pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listShift: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateShift();
        this.getDataShift(this.state.pagination.current, this.state.pagination.pageSize);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_SHIFT_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    <BreadCrumbs
                        parentMenu="Master Data"
                        serviceMenu="Shift"
                        title="Shift"
                    />

                    <div className="space-y-3">
                        {/* FILTER */}
                        <div className="flex justify-between items-center flex-row-reverse">
                            {/* Add Shift */}
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_SHIFT_INSERT]} userPermission={this.props.userDetail.permissions}>
                                <div
                                    id="btnadd"
                                    className="flex items-center cursor-pointer bg-nexcaredefault text-white py-2 px-6 rounded-lg"
                                    onClick={this.handleRedirectAddShift}
                                >
                                    <IconAddBlueBorder />
                                    <span className="ml-2">Shift</span>
                                </div>
                            </CheckPermissionComponent>
                        </div>

                        {/* CONTENT */}
                        <div className="bg-white rounded-2xl">
                            <TableNexcare
                                column={this.state.columns}
                                dataTable={this.state.listShift}
                                pagination={this.state.pagination}
                                onPage={this.handleSelectedPage}
                                onPageSize={this.handleSelectedPageSize}
                            />
                        </div>
                    </div>

                    <Alert show={this.state.showConfirmAlert} button title="Hapus Shift" desc="Apakah Anda yakin ingin menghapus data?" close={() => this.setState({ showConfirmAlert: false, shiftDataSelectedDelete: {} })} submit={() => this.handleDeleteShift()} />
                    <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil" desc="Data berhasil dihapus" close={this.handleSuccessDeleteShift} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Shift);